//React
import * as React from "react";
//Material UI
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
//Components
import { DangerButton, GhostButton } from "../../Global/other/Buttons";

/**
 * Destructive confirmation, built to the design system's shared
 * `neura.confirm()` (`.neura-confirm__card` in assets/neura.css).
 *
 * Replaces a bespoke second MUI Dialog whose buttons read "No, Cancel" / "Yes"
 * and whose title was "Delete User" — the design names the subject and the
 * consequence instead.
 */
export default function ConfirmDialog({
  open,
  title,
  body,
  cancelLabel = "Cancel",
  confirmLabel,
  onCancel,
  onConfirm,
}) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="confirm-title"
      BackdropProps={{
        sx: { backgroundColor: "rgba(8, 11, 16, 0.6)", backdropFilter: "blur(4px)" },
      }}
      PaperProps={{
        sx: {
          background: "var(--surface)",
          border: "1px solid var(--border-strong)",
          borderRadius: "var(--radius-xl)",
          padding: "22px 24px 18px",
          maxWidth: "420px",
          width: "100%",
          boxShadow: "var(--shadow-pop)",
        },
      }}
    >
      <Box
        component="h2"
        id="confirm-title"
        sx={{ margin: "0 0 6px", fontSize: "1rem", fontWeight: 600, color: "var(--text)" }}
      >
        {title}
      </Box>
      <Box
        component="p"
        sx={{
          margin: "0 0 18px",
          fontSize: "0.86rem",
          lineHeight: 1.5,
          color: "var(--text-secondary)",
        }}
      >
        {body}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <GhostButton type="button" onClick={onCancel}>
          {cancelLabel}
        </GhostButton>
        <DangerButton type="button" onClick={onConfirm}>
          {confirmLabel}
        </DangerButton>
      </Box>
    </Dialog>
  );
}
